const formatSkus = (skuList) => {
    let skus = {}
    Object.keys(skuList).map(key => skus[key] = { quantity: skuList[key].qty, total: skuList[key].price.totalCost })
    return skus
}

module.exports = {formatSkus}